// Core
import styled from 'styled-components';

// Component
import { ModuleIFMStatus } from './ModuleIFM.types';

// Types
import { Theme } from '../../types/theme';

/**
 * Returns the color of the status based on the status enum.
 * @param {ModuleIFMStatus} status - The status of the module.
 * @param {Theme} theme - The theme of the module.
 * @returns {string} The color of the status.
 */
const getModuleStatusColor = (status: ModuleIFMStatus, theme: Theme): string => {
  const statusColorMap = {
    [ModuleIFMStatus.success]: theme.color.moduleIFM.statusSuccessColor,
    [ModuleIFMStatus.neutral]: theme.color.moduleIFM.statusNeutralColor,
  };

  return statusColorMap[status] || theme.color.moduleIFM.statusNeutralColor;
};

export const Container = styled.div<{ isVertical: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 8px;
  border: 1px solid ${({ theme }) => theme.color.moduleIFM.containerBorderColor};
  background-color: ${({ theme }) => theme.color.moduleIFM.containerBackgroundColor};
  border-radius: 6px;
  width: 163px;
`;

export const ItemsContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 4px;
`;

export const ItemsContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 24px;
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  width: 55px;
`;

export const CenterSection = styled.div`
  display: flex;
  justify-content: center;
  width: 45px;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 55px;
`;

export const CentralValue = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 8px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.color.moduleIFM.valueBorderColor};
  background-color: ${({ theme }) => theme.color.moduleIFM.valueBackgroundColor};
  min-width: 25px;
  height: 22px;
`;

export const Status = styled.span<{ status: ModuleIFMStatus }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ status, theme }) => getModuleStatusColor(status, theme)};
  margin-right: 4px;
  flex-shrink: 0;
`;

export const StatusRight = styled(Status)`
  margin-right: 0;
  margin-left: 4px;
`;
